/* eslint-disable @typescript-eslint/ban-ts-comment */
import { ButtonType, TextInputType } from "../../enums/componentEnums";
import AppButton from "../Inputs/AppButton";
import AppDateInput from "../Inputs/AppDate";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { setStartDate, setEndDate } from "../../store/filterSlice";
import { ChangeEvent, useEffect, useState } from "react";
import { enqueueSnackbar } from "notistack";
import { useUtils } from "../../customHooks/useUtils";

function FilterComponent() {
  const { t } = useUtils();
  const dispatch = useAppDispatch();

  // Redux state
  const reduxStartDate = useAppSelector((state) => state.filter.startDate);
  const reduxEndDate = useAppSelector((state) => state.filter.endDate);

  // Local state
  const [startDate, setStartDateState] = useState(reduxStartDate);
  const [endDate, setEndDateState] = useState(reduxEndDate);
  const [isLocalLoading, setIsLocalLoading] = useState(false);

  const ERROR_MESSAGES = {
    START_GT_END: t("error_msg.start_gt_end"),
    END_LT_START: t("error_msg.end_lt_start"),
    RANGE_EXCEED: t("error_msg.range_exceed"),
    FUTURE_DATE: t("error_msg.future_date"),
  };

  // Utility function to calculate date difference
  // const getDateDifference = (start: string, end: string) => {
  //   const startDateObj = new Date(start);
  //   const endDateObj = new Date(end);
  //   return Math.ceil(
  //     (endDateObj.getTime() - startDateObj.getTime()) / (1000 * 3600 * 24)
  //   );
  // };

  // Validation function that returns true if valid, or displays an error and returns false
  const validateDates = (start: string, end: string) => {
    // Check if start date is greater than end date
    if (new Date(start) > new Date(end)) {
      enqueueSnackbar(ERROR_MESSAGES.START_GT_END, { variant: "error" });
      return false;
    }

    // Check if date range exceeds 31 days
    // if (getDateDifference(start, end) > 31) {
    //   enqueueSnackbar(ERROR_MESSAGES.RANGE_EXCEED, { variant: "error" });
    //   return false;
    // }

    // Check if end date is in the future
    if (new Date(end) > new Date()) {
      enqueueSnackbar(ERROR_MESSAGES.FUTURE_DATE, { variant: "error" });
      return false;
    }

    return true;
  };

  const handleStartDateChange = (e: ChangeEvent<HTMLInputElement>) => {
    const newStartDate = e.target.value;
    setStartDateState(newStartDate);
  };

  const handleEndDateChange = (e: ChangeEvent<HTMLInputElement>) => {
    const newEndDate = e.target.value;
    setEndDateState(newEndDate);
  };

  const applyFilter = () => {
    // Validate dates only when applying the filter
    if (!validateDates(startDate, endDate)) {
      return;
    }

    setIsLocalLoading(true);
    dispatch(setStartDate(startDate));
    dispatch(setEndDate(endDate));

    setTimeout(() => {
      setIsLocalLoading(false);
    }, 2500);
  };

  useEffect(() => {
    setStartDateState(reduxStartDate);
  }, [reduxStartDate]);

  useEffect(() => {
    setEndDateState(reduxEndDate);
  }, [reduxEndDate]);

  return (
    <div className="w-full flex flex-wrap items-end justify-start gap-6 lg:gap-4">
      {/* Start Date Input */}
      <div className="flex flex-col min-w-[100px] items-start overflow-x-hidden">
        <AppDateInput
          name="startDate"
          value={startDate}
          topLabel={t("filter.start_date")}
          onChange={handleStartDateChange}
          type={TextInputType.DATE}
        />
      </div>

      {/* End Date Input */}
      <div className="flex flex-col min-w-[100px]  items-start">
        <AppDateInput
          name="endDate"
          value={endDate}
          topLabel={t("filter.end_date")}
          onChange={handleEndDateChange}
          type={TextInputType.DATE}
        />
      </div>

      {/* Apply Filter Button */}
      <div className="flex flex-col min-w-[100px]  items-start">
        <AppButton
          type={ButtonType.PRIMARY}
          text={t("filter.apply_filter")}
          className="p-2"
          handleClick={applyFilter}
          disabled={isLocalLoading}
        />
      </div>
    </div>
  );
}

export default FilterComponent;
